import React, { useEffect, useState } from 'react';
import MESSAGES from '../../../../common/data/constants/messages';
import { ITraining } from '../../../../common/data/dtos/training';
import PaginationButtons, { dataPagination, PER_COUNT } from '../../../../components/PaginationButtons';
import Badge from '../../../../components/bootstrap/Badge';
import Button from '../../../../components/bootstrap/Button';
import Card, { CardActions, CardBody, CardHeader, CardLabel, CardTitle } from '../../../../components/bootstrap/Card';
import { MoreActions } from '../../../../components/extras/MoreActions';
import { showSuccess, showWarning } from '../../../../components/extras/Notifications';
import trainingService from '../../../../services/training-service';
import LoadingPage from '../../loading/LoadingPage';
import TrainingModal from './TrainingModal';

const CommonTrainingList = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(PER_COUNT['10']);

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isModalOpened, setIsModalOpened] = useState(false);

    const [trainings, setTrainings] = useState<ITraining[]>([]);
    const [selectedTraining, setSelectedTraining] = useState<ITraining | null>(null);

    useEffect(() => {
        fetchTrainings();
    }, []);

    const fetchTrainings = async () => {
        setIsLoading(true);

        const response = await trainingService.getTrainings();

        setIsLoading(false);

        if (response.error) {
            showWarning(response.error);
            return;
        }

        setTrainings(response.trainings || []);
    };

    const toggleModal = (setter: React.Dispatch<React.SetStateAction<boolean>>, isVisible: boolean) => {
        setter(isVisible);
    };

    const handleAddClick = () => {
        toggleModal(setIsModalOpened, true);
    };

    const onModalClose = () => {
        toggleModal(setIsModalOpened, false);
        setSelectedTraining(null);
    };

    const onAfterSubmit = async () => {
        await fetchTrainings();
        onModalClose();
    };

    const handleDeleteClick = async (training: ITraining) => {
        if (!training.id) {
            showWarning(MESSAGES.ACTION.DELETE_ID_ERROR);
            return;
        }

        setIsLoading(true);

        const response = await trainingService.deleteTraining(training.id);

        setIsLoading(false);

        if (response.error) {
            showWarning(response.error);
            return;
        }

        showSuccess(MESSAGES.ACTION.DELETED);
        await fetchTrainings();
    };

    const handleEditClick = (training: ITraining) => {
        setSelectedTraining(training);
        toggleModal(setIsModalOpened, true);
    };

    if (isLoading) {
        return <LoadingPage />;
    }

    return (
        <>
            <Card style={{ minHeight: 600 }}>
                <CardHeader borderSize={1}>
                    <CardLabel icon="School" iconColor="primary">
                        <CardTitle tag="div" className="h5">
                            Treinamentos
                        </CardTitle>
                    </CardLabel>
                    <CardActions>
                        <Button color="light" icon="AddCircle" onClick={handleAddClick}>
                            Adicionar
                        </Button>
                    </CardActions>
                </CardHeader>
                <CardBody className="table-responsive">
                    <table className="table table-modern table-hover">
                        <thead>
                            <tr>
                                <th>Nome</th>
                                <th>Validade (Dias)</th>
                                <th>Status</th>
                                <td aria-labelledby="Actions" />
                            </tr>
                        </thead>
                        <tbody>
                            {dataPagination(trainings, currentPage, perPage).map((item: ITraining) => (
                                <tr key={item.id}>
                                    <td>{item.name}</td>
                                    <td>{item.validity}</td>
                                    <td>
                                        {item.status ? (
                                            <h5>
                                                <Badge color="success" className="align-items-center justify-content-center">
                                                    Ativo
                                                </Badge>
                                            </h5>
                                        ) : (
                                            <h5>
                                                <Badge color="danger" className="align-items-center justify-content-center">
                                                    Inativo
                                                </Badge>
                                            </h5>
                                        )}
                                    </td>

                                    <MoreActions id={item.id} showEdit showDelete onEditClick={() => handleEditClick(item)} onDeleteClick={() => handleDeleteClick(item)} />
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </CardBody>
                <PaginationButtons data={trainings} label="items" setCurrentPage={setCurrentPage} currentPage={currentPage} perPage={perPage} setPerPage={setPerPage} />
            </Card>

            <TrainingModal isModalOpened={isModalOpened} onModalClose={onModalClose} onAfterSubmit={onAfterSubmit} selectedTraining={selectedTraining} />
        </>
    );
};

export default CommonTrainingList;
